
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(0 5)"}},[_c('path',{attrs:{"d":"M38.57 7.61l-1.687 1.074 1.687-1.073zm-2.686-4.22l1.688-1.074-1.688 1.073zm-19.768 0l-1.688-1.074 1.688 1.073zm2.53.61h14.707V0H18.647v4zm-3.53 4.684l2.687-4.22-3.375-2.148-2.686 4.22 3.375 2.148zM5 11h5.899V7H5v4zM4 37V12H0v25h4zm43 1H5v4h42v-4zm1-26v25h4V12h-4zm-6.899-1H47V7h-5.899v4zm-6.904-6.537l2.686 4.221 3.375-2.147-2.687-4.221-3.374 2.147zM41.1 7a1 1 0 01-.843-.463l-3.375 2.147A5 5 0 0041.101 11V7zM52 12a5 5 0 00-5-5v4a1 1 0 011 1h4zm-5 30a5 5 0 005-5h-4a1 1 0 01-1 1v4zM0 37a5 5 0 005 5v-4a1 1 0 01-1-1H0zM5 7a5 5 0 00-5 5h4a1 1 0 011-1V7zm6.742-.463A1 1 0 0110.9 7v4a5 5 0 004.218-2.316l-3.375-2.147zM33.353 4a1 1 0 01.844.463l3.374-2.147A5 5 0 0033.353 0v4zM18.647 0a5 5 0 00-4.218 2.316l3.374 2.147A1 1 0 0118.647 4V0z"}}),_c('circle',{attrs:{"data-stroke-colored":"true","fill":"none","stroke-width":"4","cx":"26","cy":"23","r":"8"}})])])
          )
        }
      }
    